import type { FC } from "react";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

interface ICustomBulletWrapperProps {
    color: string;
}

const CustomBulletWrapper = styled(CenteredFlexColumn)<ICustomBulletWrapperProps>`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-image: ${({ color }) => `
        linear-gradient(
            -45deg,
            ${color} 0%,
            ${color} 19%,
            #ffffff 20%,
            #ffffff 39%,
            ${color} 40%,
            ${color} 59%,
            #ffffff 60%,
            #ffffff 79%,
            ${color} 80%,
            ${color} 100%
        )
    `};
`;

interface ICustomBullet {
    color: string;
}

const CustomBullet: FC<ICustomBullet> = ({ color }) => {
    return (
        <CustomBulletWrapper
            data-automation="CustomBullet"
            color={color}
        />
    );
};

export const CustomBulletContainer = styled.div`
    width: 8px;
    height: 8px;
    align-self: center;
    margin-right: 5px;
`;

export default CustomBullet;
